module.exports = __webpack_public_path__ + "static/img/team.20c34d9f.svg";